import { CONST } from "../../CONST";


const config = {
    position: {x: 47, y: 45},
    spacing: 54,
    depth: 10,

    anim: { //heart fade
        duration: 500,
        ease: "Quad.easeInOut",
    }
}

export class HeartDisplay {
    private scene: Phaser.Scene;

    private hearts : Heart[] = [];

    constructor(scene: Phaser.Scene, hearts: number){
        this.scene = scene;

        for (let i = 0; i < hearts; i++){
            this.hearts.push(new Heart(scene, config.position.x + i * config.spacing, config.position.y, true));
        }
    }

    public updateHearts(heartCount: number){
        for (let i = 0; i < this.hearts.length; i++){
            this.hearts[i].setState(i < heartCount);
        }
    }
}

class Heart {
    private scene: Phaser.Scene;

    private bg : Phaser.GameObjects.Image;
    private heart:  Phaser.GameObjects.Image;
    private isFull: boolean;
    private fadeTween !: Phaser.Tweens.Tween;

    constructor(scene: Phaser.Scene, x: number, y: number, isFull: boolean){
        this.scene = scene;
        this.bg = scene.add.image(x, y, CONST.INSTRUMENT.HEART_EMPTY).setDepth(config.depth);
        this.heart = scene.add.image(x, y, CONST.INSTRUMENT.HEART).setDepth(config.depth + 1);

        this.isFull = isFull;
        if (!isFull){
            this.heart.setAlpha(0);
        }
    }

    public setState(full: boolean){
        this.isFull = full;
        let targetAlpha = full ? 1 : 0;

        if (this.fadeTween){
            this.fadeTween.stop();
        }

        this.fadeTween = this.scene.tweens.add({
            targets: this.heart,
            alpha: targetAlpha,
            delay: 250,
            duration: config.anim.duration,
            ease: config.anim.ease,
        })

    }
}